/* eslint-disable no-console */
import jwt from "jsonwebtoken";

// LocalStorage //
const issuerLs = "w4kd0y0k";
const subjectLs = "w4kd0y0kc1234m";
const audienceLs = "50b4t4mby412";
const expiresInLs = "1d";
// End LocalStorage //

// Data From Server //
const issuer = "ITC Finance";
const subject = "Subject";
const audience = "https://itcfinance.com";
const expiresIn = "1d";
// End Data From Server

export const JWTSign = (payload, secret, ls = false) => {
  const jwtSignOptions = {
    issuer: ls ? issuerLs : issuer,
    subject: ls ? subjectLs : subject,
    audience: ls ? audienceLs : audience,
    expiresIn: ls ? expiresInLs : expiresIn,
    algorithm: "HS256",
  };
  return ls
    ? jwt.sign(payload, secret, jwtSignOptions)
    : jwt.sign(payload, secret);
};
export const JWTVerify = (token, secret, ls = false) => {
  const jwtVerifyOptions = {
    issuer: ls ? issuerLs : issuer,
    subject: ls ? subjectLs : subject,
    audience: ls ? audienceLs : audience,
    expiresIn: ls ? expiresInLs : expiresIn,
    algorithm: "HS256",
  };
  return ls
    ? jwt.verify(token, secret, jwtVerifyOptions)
    : jwt.verify(token, secret);
};

export const lsUtils = {
  setItem: (key, payload, expirationMs = 3600000) => {
    if (typeof Storage === "undefined") {
      return false;
    }
    let record = {
      value: JSON.stringify(payload),
      expiredIn: new Date().getTime() + expirationMs,
    };
    try {
      const LSToken = JWTSign(record, process.env.VUE_APP_LS_SECRET, true);
      if (LSToken) {
        localStorage.setItem(key, LSToken);
        return LSToken;
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  },
  getItem: (key) => {
    if (typeof Storage === "undefined") {
      return false;
    }
    let LSToken = localStorage.getItem(key);
    if (!LSToken) {
      return false;
    }
    try {
      let record = JWTVerify(LSToken, process.env.VUE_APP_LS_SECRET, true);
      let recExp = record.expiredIn;
      if (recExp < new Date().getTime()) {
        localStorage.removeItem(key);
        return false;
      } else {
        return JSON.parse(record.value);
      }
    } catch (error) {
      return false;
    }
  },
  removeItem: (key) => {
    if (typeof Storage === "undefined") {
      return false;
    }
    localStorage.removeItem(key);
    return true;
  },
};
